<ng-container class="report-custom-container"
  ><app-report-select
    [title]="'Reporte de polimedicación'"
    (previewClicked)="handlePreviewClick()"
    (printClicked)="handlePrintClick()"
    (pdfClicked)="handlePdfClick()"
    (excelClicked)="handleExcelClick()"
  >
  <div slot="content" class="container-options">
      <form [formGroup]="form">
     
          <section class="filter-container" >
            <div class="subtitle">Centro</div>
            <app-form-field
              class="field"
              [type]="'select'"
              label="Selecciona un centro"
              [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
              [options]="selectOptionsInsitutions">
            </app-form-field>
    
          </section>

        <section class="filter-container">
          <div class="subtitle">Día del reporte</div>

            <mat-form-field
            >
              <input
                matInput
                [matDatepicker]="specificDay"
                formControlName="specificDay"
              />
              <mat-datepicker-toggle
                matSuffix                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
                [for]="specificDay"
              ></mat-datepicker-toggle>
              <mat-datepicker #specificDay></mat-datepicker>
            </mat-form-field>
        </section>
      </form>
    </div>
  </app-report-select>
</ng-container>
